import axios from 'axios';

const cityService = (stateInitial: string) => axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${stateInitial}/municipios?orderBy=nome`);

export default {
    cityService
};

